'use client'

import type { ITokenService } from '@/core/services/tokens/token.service.interface'
import { create } from 'zustand'

type TokenState = {
  token: string | null
}

type TokenActions = ITokenService

export const useTokenStore = create<TokenState & TokenActions>((set, get) => ({
  token: null,

  async getToken() {
    const { token } = get()
    return { token }
  },

  async setToken(token) {
    set({ token })
  },

  async clearToken() {
    set({ token: null })
  },
}))

export const createMemroyTokenService = (): ITokenService => ({
  getToken: () => useTokenStore.getState().getToken(),
  setToken: token => useTokenStore.getState().setToken(token),
  clearToken: () => useTokenStore.getState().clearToken(),
})
